























import Vue from "vue";
import { ExtOrderItem, InvoiceItem, InvoiceRelationType, SalesAndOpportunity, Stock } from "../models";
import { formatDate } from "@/utils/formatDates";
import GPart, { getFlags } from "@/modules/gpartsEdit/models/GPart";

const displayNames = (item: InvoiceItem) => {
  const result = [];
  
  const stock = item.relations.find((i) => i.type === InvoiceRelationType.Stock)?.relatedItem as Stock;
  if (stock && !item.isService) {
    result.push(`Szállítólevél: ${stock.deliveryNumber ?? "-"}`);
    if (stock.orderNumber) {
      result.push(`Rendelés száma: ${stock.orderNumber}`);
    }
    return result;
  }

  const orderItem = item.relations.find((i) => i.type === InvoiceRelationType.ExtOrderItem)?.relatedItem as ExtOrderItem;
  if (orderItem) {
    result.push(
      orderItem.orderNumber ? `Rendelés száma: ${orderItem.orderNumber}` : item.orderNumber ? item.orderNumber : "",
      (orderItem.originalStock > 1) ? `${orderItem.originalStock} stock cseréje` : ""
    );
    return result.filter((i) => i);
  }

  const salesOrderRelation = item.relations.find((r) => r.type === InvoiceRelationType.SalesOrder);
  if (salesOrderRelation) {
    const salesOrderData = salesOrderRelation.relatedItem as SalesAndOpportunity;
    result.push(`Értékesítés: ${salesOrderData.salesOrderNo}`)
    return result;
  }

  if (item.car > 1 || item.prCar > 1) {
    result.push(`Modell: ${item.carDetails.model}`, `Alvázszám: ${item.carDetails.bodyNo}`);
    if (item.car > 1) {
      result.unshift(`Gépjármű: ${item.car}`);
    } else {
      result.unshift(`Gépjármű rendelés: ${item.prCar}`);
    }
    return result;
  }

  if ((item as any).bodyNo) {
    result.push(`Alvázszám: ${(item as any).bodyNo}`);
  }

  const service = item.relations.find((i) => i.type === InvoiceRelationType.Service)?.relatedItem as GPart;
  if (service) {
    result.unshift(`Cikkszám: ${service.code ?? "-"}`);
  }
  return result;
};

const toolTipInfos = (item: InvoiceItem) => {
  const stock = item.relations.find((i) => i.type === InvoiceRelationType.Stock)?.relatedItem as Stock;
  const result = [];
  if (stock) {
    result.push(`Betárolás: ${stock.storeInID}`);
    result.push(`Betárolás dátuma: ${formatDate(new Date(stock.stockDate))}`);
    result.push(`Batch: ${stock.batchNumber}`);
    result.push(`Cikkszám: ${stock.productCode}`);
  }

  return result;
}

const serviceFlags = (item: InvoiceItem) => {
  const service = item.relations.find((i) => i.type === InvoiceRelationType.Service)?.relatedItem as GPart;
  if (service) {
    return getFlags(service);
  }
}

export default Vue.extend({
  props: {
    item: {
      type: Object as () => InvoiceItem,
    },
  },

  computed: {
    displayNames() {
      return displayNames(this.item);
    },

    toolTipInfos() {
      return toolTipInfos(this.item);
    },

    flags() {
      return serviceFlags(this.item);
    }
  },
});
